An array of offered salary ranges.

Scheme requirements:

- The `seekAnz` scheme is limited to a single element containing the amount for the `basisCode`.

Salary ranges are used to refine candidate job searches.
While the monetary values in `minimumAmount` and `maximumAmount` are not visible on job ads,
the currency and interval may be displayed alongside the `descriptions` of the remuneration package for clarity.
